import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import TagFilterPane from '@/components/Hub/TagFilterPane';
import HubRepoList from '@/components/HubRepoList';
import { PageTitle } from '@/components/PageTitle';

const HubSearch = () => {
  const [searchParams, _] = useSearchParams();
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const q = searchParams.get('q') || '';

  return (
    <div className="flex flex-grow items-start gap-4">
      <div className="flex-grow basis-0" />
      <div className="flex flex-grow-0 basis-[768px] flex-col gap-4">
        <PageTitle>Search: {q}</PageTitle>
        <HubRepoList searchTerm={q} tags={selectedTags} />
      </div>
      <div className="flex-grow basis-0" />
      <div className="flex flex-grow basis-[150px] flex-col items-stretch self-stretch">
        <TagFilterPane
          selectedTags={selectedTags}
          setSelectedTags={setSelectedTags}
          query={q}
          className="flex-grow"
        />
      </div>
    </div>
  );
};

export default HubSearch;
